import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import emailjs from "@emailjs/browser";
import "./Survey.css";
import { toast } from "react-toastify";

const Survey = () => {
    const questions = [
        "Hastaneye ulaşımda zorluk yaşamadım",
        "Danışma ve yönlendirme hizmetleri yeterliydi",
        "Hastane içinde ulaşmam birimlere kolaylıkla ulaşabildim",
        "Muayene olacağım doktoru kendim seçtim",
        "Kayıt işlemleri için çok beklemedim",
        "Bekleme alanının fiziki koşulları yeterliydi",
        "Muayene olmak için beklediğim süre uygundu",
        "Muayene odasının fiziki koşulları yeterliydi",
        "Doktorumun bana ayırdığı süre yeterliydi",
        "Tahlil ve tetkikler için verilen randevu süreleri uygundu",
        "Tahlil ve tetkik sonuçlarımı belirtilen süre içerisinde aldım",
        "Doktorum tarafından hastalığım ve tedavim ile ilgili yeterli bilgilendirme yapıldı",
        "Muayene ve tetkikler sırasında kişisel mahremiyetime özen gösterildi",
        "Hastane personelinin bana karşı davranışları nezaket kurallarına uygundu.",
        "Hastane genel olarak temizdi",
        "Hastanenin sunmuş olduğu hizmetler beklentilerimi karşıladı",
        "Bu hastaneden, hiç kimsenin yardımına ihtiyaç duymadan ve kolayca hizmet alabilirim",
        "Bu hastaneyi aileme ve arkadaşlarıma tavsiye ederim",
    ];

    const options = [
        "Tamamen katılıyorum",
        "Katılıyorum",
        "Kararsızım",
        "Katılmıyorum",
        "Kesinlikle katılmıyorum",
    ];

    const [patientInfo, setPatientInfo] = useState({
        date: new Date().toLocaleDateString(),
        polyclinic: "",
        isPatient: "",
        gender: "",
        ageCategory: "",
        literacy: "",
    });

    const [answers, setAnswers] = useState({});
    const [feedback, setFeedback] = useState("");
    const [error, setError] = useState("");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPatientInfo({
            ...patientInfo,
            [name]: value,
        });
    };

    const handleSelect = (question, answer) => {
        setAnswers({ ...answers, [question]: answer });
    };

    const handleFeedbackChange = (e) => {
        setFeedback(e.target.value);
    };

    const handleSubmit = async () => {
        if (!patientInfo.polyclinic || !patientInfo.isPatient || !patientInfo.gender || !patientInfo.ageCategory || !patientInfo.literacy) {
            setError("Lütfen tüm alanları doldurunuz.");
            toast.warn("Lütfen tüm alanları doldurunuz")
            return;
        }

        if (Object.keys(answers).length !== questions.length) {
            setError("Lütfen tüm soruları yanıtlayın.");
            toast.warn("Lütfen tüm soruları yanıtlayın.")
            return;
        }

        setError("");
        const surveyData = {
            ...patientInfo,
            answers,
            feedback: feedback
        };

        try {
            await addDoc(collection(db, "surveyResponses"), surveyData);
            sendEmail(surveyData);
            toast.success("Cevaplarınız kaydedildi ve yönetime gönderildi.");
        } catch (error) {
            toast.error("Bir hata oluştu, lütfen tekrar deneyin.");
        }
    };

    const formatSurveyData = (surveyData) => {
        let formattedText = `Başvurulan Poliklinik: ${surveyData.polyclinic}\n`;
        formattedText += `Hasta Yakınlığı: ${surveyData.isPatient}\n`;
        formattedText += `Cinsiyet: ${surveyData.gender}\n`;
        formattedText += `Yaş Kategorisi: ${surveyData.ageCategory}\n`;
        formattedText += `Okuryazarlık Durumu: ${surveyData.literacy}\n\n`;
        formattedText += "Anket Cevapları:\n";

        Object.entries(surveyData.answers).forEach(([question, answer], index) => {
            formattedText += `${index + 1}. ${question} - ${answer}\n`;
        });

        if (surveyData.feedback) {
            formattedText += `\nDilek/Öneri/Şikayet: ${surveyData.feedback}\n`;
        }

        return formattedText;
    };

    const sendEmail = (surveyData) => {
        const emailParams = {
            to_email: "janberk.altay@destade.com",
            message: formatSurveyData(surveyData),
        };

        emailjs.send(
            "service_78wir1a",
            "template_g74t5cf",
            emailParams,
            "vkfDhkMC-ShkF_Yvh"
        ).then(
            (response) => console.log("Email başarıyla gönderildi", response),
            (error) => console.error("Email gönderilirken hata oluştu", error)
        );
    };

    return (
        <div className="survey-container">
            <h2 className="survey-title">Hasta Deneyimi Anketi</h2>

            {error && <p className="error-message">{error}</p>}

            <div className="survey-form">
                <label>Başvurulan Poliklinik:
                    <input type="text" name="polyclinic" onChange={handleInputChange} required />
                </label>

                <label>Hasta Yakınlığı:
                    <select name="isPatient" onChange={handleInputChange} required>
                        <option value="">Seçiniz</option>
                        <option value="Hasta">Hasta</option>
                        <option value="Hasta Yakını">Hasta Yakını</option>
                    </select>
                </label>

                <label>Cinsiyet:
                    <select name="gender" onChange={handleInputChange} required>
                        <option value="">Seçiniz</option>
                        <option value="Erkek">Erkek</option>
                        <option value="Kadın">Kadın</option>
                        <option value="Belirtmek İstemiyorum">Belirtmek İstemiyorum</option>
                    </select>
                </label>

                <label>Yaş Kategorisi:
                    <select name="ageCategory" onChange={handleInputChange} required>
                        <option value="">Seçiniz</option>
                        <option value="20 altı">20 altı</option>
                        <option value="20-29">20-29</option>
                        <option value="30-39">30-39</option>
                        <option value="40-49">40-49</option>
                        <option value="50-59">50-59</option>
                        <option value="60 üstü">60 üstü</option>
                    </select>
                </label>

                <label>Okuryazarlık Durumu:
                    <select name="literacy" onChange={handleInputChange} required>
                        <option value="">Seçiniz</option>
                        <option value="Okuryazar değil">Okuryazar değil</option>
                        <option value="Okuryazar">Okuryazar</option>
                        <option value="İlkokul">İlkokul</option>
                        <option value="Ortaokul">Ortaokul</option>
                        <option value="Lise">Lise</option>
                        <option value="Üniversite">Üniversite</option>
                    </select>
                </label>
            </div>

            {questions.map((question, index) => (
                <div key={index} className="survey-question">
                    <p>{question}</p>
                    <div className="survey-options">
                        {options.map((option, i) => (
                            <label key={i}>
                                <input type="radio" name={question} value={option} onChange={() => handleSelect(question, option)} />
                                {option}
                            </label>
                        ))}
                    </div>
                </div>
            ))}

            <div className="survey-feedback">
                <label>
                    <p>Dilek / Öneri / Şikayet:</p>
                    <textarea
                        name="feedback"
                        value={feedback}
                        onChange={handleFeedbackChange}
                        placeholder="Varsa dilek, öneri veya şikayetlerinizi buraya yazabilirsiniz..."
                        rows={5}
                    />
                </label>
            </div>

            <button onClick={handleSubmit} className="submit-btn">Gönder</button>
        </div>
    );
};

export default Survey;